import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Alert, Box, Typography } from 'shared/ui'
import { type VerifyNumberStore } from 'pages/settings/ui/VerifyNumberCommon/store/VerifyNumberStore'
import { VerifyNumberExt } from './VerifyNumberExt'
import { VerifyNumberCode } from './VerifyNumberCode'
import styles from './styles.module.scss'

export const VerifyNumberCommon = observer(({ store }: { store: VerifyNumberStore }) => {
  const { title, verificationCode, error, disposeStep } = store

  useEffect(() => {
    return () => {
      disposeStep()
    }
  }, [])

  return (
    <div className={styles.wrap}>
      <Typography
        tag={'div'}
        color='tertiary'
        variant='body-md-regular'
        ariaLabel='EnterNumberDescription'
        marginTop='16px'
      >
        {title}
      </Typography>

      {error && (
        <Box marginTop={'20px'}>
          <Alert
            item={{
              type: 'error',
              desc: error,
            }}
          />
        </Box>
      )}

      <div className={styles.content}>
        {!verificationCode && <VerifyNumberExt store={store} />}
        {verificationCode && <VerifyNumberCode store={store} />}
      </div>
    </div>
  )
})
